<div class="modal-header mb-10">
  <div class="modal-title">
    <h3 class="d-inline-block">Issue Report — {{ phoneReport().phone }}</h3>
    <button type="button" class="btn-close" (click)="dialogRef().close(false)">
      <span class="icon-close"></span>
    </button>
  </div>
</div>

<div class="modal-body">
<div class="outcome-modal-body">
  <!-- Resolution section -->
  @if (isAdmin()) {
    <div class="outcome-card">
      <div class="outcome-card-header">Resolution</div>
      <div class="outcome-card-content">
        <form [formGroup]="phoneReportOutcomeForm">
          <div class="d-flex align-items-center gap-10 mb-10">
            <label class="form-label mb-0 text-muted flex-shrink-0">Status</label>
            <select class="form-control form-select input-sm outcome-resolution-select" formControlName="outcomeResolution">
              @for (option of outcomeResolutionOptions; track option.value) {
                <option [ngValue]="option.value">{{ option.label }}</option>
              }
            </select>
          </div>

          <div class="form-group mb-10">
            <label class="form-label mb-0_5 text-muted">Description</label>
            <textarea class="form-control outcome-description-textarea" formControlName="outcomeDescription" rows="2"
                      placeholder="Add a description..."></textarea>
            <input-errors [control]="phoneReportOutcomeForm.controls.outcomeDescription" [service]="validationService"></input-errors>
          </div>

          <div class="d-flex justify-content-end gap-10">
            <button class="btn btn-sm btn-outline-dark" [disabled]="isReportOutcomeUpdating()" (click)="onCancelClick()">Cancel</button>
            <button
              class="btn btn-sm btn-primary"
              type="submit"
              [disabled]="isReportOutcomeUpdating() || phoneReportOutcomeForm.invalid"
              (click)="onOutcomeCommentSaveClick()">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  } @else if (phoneReport().outcomeResolution || phoneReport().outcomeDescription) {
    <div class="outcome-card">
      <div class="outcome-card-header">Resolution</div>
      <div class="outcome-card-content">
        @if (phoneReport().outcomeResolution) {
          <span class="badge resolution-badge" [ngClass]="getResolutionBadgeClass()">
            {{ outcomeResolutionLabel() }}
          </span>
        }
        @if (phoneReport().outcomeDescription) {
          <p class="outcome-description-value text-muted mb-0" [class.mt-10]="phoneReport().outcomeResolution">{{ phoneReport().outcomeDescription }}</p>
        }
      </div>
    </div>
  }

  <!-- Internal Test Results section -->
  @if (phoneReport().backupTestId) {
    <app-phone-reports-test-result-table [reportId]="phoneReport().id"></app-phone-reports-test-result-table>
  } @else {
    <div class="outcome-card">
      <div class="outcome-card-header">Internal test result</div>
      <div class="outcome-card-content">
        <p class="text-muted mb-0">No test required</p>
      </div>
    </div>
  }

  <!-- Test Connectivity Info section -->
  <div class="outcome-card">
    <div class="outcome-card-header">Connectivity</div>
    <div class="outcome-card-content">
      <app-phone-report-connectivity-info [info]="connectivityInfo()"></app-phone-report-connectivity-info>
    </div>
  </div>
</div>
</div>
